/**
 * GDL Live Visitors — Firebase Realtime Presence
 *
 * Tracks real-time visitors per product page using Firebase Realtime Database.
 * Each visitor registers a timestamped entry; stale entries (>5 min) are cleaned.
 * Uses onDisconnect() for automatic cleanup when the tab closes.
 *
 * Requires: firebase-app-compat.js + firebase-database-compat.js loaded before this script.
 * Expects: window.GDL_FIREBASE_CONFIG and window.GDL_PRODUCT_ID to be set.
 */
(function () {
  'use strict';

  var config = window.GDL_FIREBASE_CONFIG;
  var productId = window.GDL_PRODUCT_ID;
  var countEl = document.getElementById('gdl-drop-buyers-count');
  var buyersRow = countEl ? countEl.closest('.gdl-drop-buyers') : null;

  if (!config || !config.databaseURL || !productId || !countEl) return;
  if (typeof firebase === 'undefined') return;

  // Initialise Firebase (only once)
  if (!firebase.apps.length) {
    firebase.initializeApp(config);
  }

  var db = firebase.database();
  var STALE_MS = 5 * 60 * 1000; // 5 minutes

  // Unique session ID (persisted per tab)
  var sessionId =
    sessionStorage.getItem('gdl_sid') ||
    (function () {
      var id = Math.random().toString(36).substring(2) + Date.now().toString(36);
      sessionStorage.setItem('gdl_sid', id);
      return id;
    })();

  var visitorRef = db.ref('visitors/' + productId + '/' + sessionId);
  var productRef = db.ref('visitors/' + productId);

  // Register presence with timestamp
  function heartbeat() {
    visitorRef.set(Date.now());
  }
  heartbeat();

  // Auto-remove on disconnect
  visitorRef.onDisconnect().remove();

  // Heartbeat every 30s to stay "alive"
  var heartbeatInterval = setInterval(heartbeat, 30000);

  // Clean up on page leave
  window.addEventListener('beforeunload', function () {
    clearInterval(heartbeatInterval);
    visitorRef.remove();
  });

  // Listen for real-time count changes
  productRef.on('value', function (snapshot) {
    var now = Date.now();
    var count = 0;

    snapshot.forEach(function (child) {
      var ts = child.val();
      if (typeof ts === 'number' && now - ts < STALE_MS) {
        count++;
      } else {
        // Remove stale entry
        child.ref.remove();
      }
    });

    if (countEl && buyersRow) {
      if (count >= 5) {
        countEl.textContent = count;
        buyersRow.style.display = '';
      } else {
        buyersRow.style.display = 'none';
      }
    }
  });
})();
